var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _path9, _path10, _path11, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle4, _rect, _path19, _path20, _g, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertEmptyScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alert_empty_screen",
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 134.583,
    viewBox: "0 0 240 134.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a08a2523-9d19-4e0c-87cb-6ce1a7fd2fc4-2650",
    d: "M20.294,110.858a40.706,40.706,0,0,0,7.4,8.742c.077.052.129.129.206.181l6.112-3.636a1.431,1.431,0,0,1-.155-.206c-3.172-4.461-17.613-34.065-17.69-40.615C16.143,75.865,10.959,96.237,20.294,110.858Z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a62b1d0a-4504-46a8-81c8-bbc6043ad63f-2651",
    d: "M26.535,120.3c.1.052.181.077.284.129l4.59-2.733a2.267,2.267,0,0,0-.258-.155c-1.573-.928-6.24-3.688-10.856-6.679-4.951-3.223-9.825-6.73-10.65-8.561C9.8,102.71,15.266,115.423,26.535,120.3Z",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "fd401fbc-93ba-42a5-a9a4-5a6900171ed6-2652",
    d: "M220.531,122.8a40.98,40.98,0,0,1-1.908,11.295c-.026.077-.052.181-.077.258h-7.117c0-.077.026-.155.026-.258.464-5.467-2.243-38.294-5.518-43.967C206.219,90.59,221.072,105.443,220.531,122.8Z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "eaa08601-a63b-4214-86e2-4a8f8e2c7e12-2653",
    d: "M219.989,134.093c-.052.077-.129.181-.181.258h-5.338a2.4,2.4,0,0,0,.129-.258c.877-1.6,3.507-6.344,5.931-11.295,2.6-5.312,5-10.8,4.8-12.816C225.379,110.446,227.184,124.139,219.989,134.093Z",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38853",
    "data-name": "Path 38853",
    d: "M115.552,134.144H33.188a7.346,7.346,0,0,1-7.349-7.349V7.349A7.363,7.363,0,0,1,33.188,0h82.338a7.346,7.346,0,0,1,7.349,7.349v119.42A7.33,7.33,0,0,1,115.552,134.144Z",
    fill: "#cacaca"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38854",
    "data-name": "Path 38854",
    d: "M115.681,129.451H33.059a2.256,2.256,0,0,1-2.269-2.269V6.963a2.256,2.256,0,0,1,2.269-2.269h82.647a2.256,2.256,0,0,1,2.269,2.269V127.182A2.312,2.312,0,0,1,115.681,129.451Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.619,
    cy: 0.619,
    r: 0.619,
    transform: "translate(73.441 1.625)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38855",
    "data-name": "Path 38855",
    d: "M239.691,134.583H.309a.309.309,0,0,1,0-.619H239.691a.3.3,0,0,1,.309.309.333.333,0,0,1-.309.309Z",
    fill: "#cacaca"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 7.994,
    cy: 7.994,
    r: 7.994,
    transform: "translate(66.376 83.627)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38856",
    "data-name": "Path 38856",
    d: "M79.373,76.278H69.367L63.333,46.726a11.107,11.107,0,0,1,22.1-2.243,10.625,10.625,0,0,1,0,2.218Z",
    fill: "#e4e4e4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38857",
    "data-name": "Path 38857",
    d: "M113.7,36.566h36.592a7.78,7.78,0,0,1,7.581,6.06l18.489,82a6.268,6.268,0,0,1-4.745,7.5,7.824,7.824,0,0,1-1.083.155l-37.6,1.857a8.3,8.3,0,0,1-8.587-6.808l-10.5-57.969-1.986-10.959-2.94-16.194a4.8,4.8,0,0,1,3.868-5.57,5.569,5.569,0,0,1,.9-.077Z",
    fill: "#373551"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38858",
    "data-name": "Path 38858",
    d: "M145.465,38.32h4.281a5.38,5.38,0,0,1,5.261,4.229l17.741,81.332a3.335,3.335,0,0,1-2.553,3.971c-.155.026-.335.052-.49.077l-37.494,2.45a4.341,4.341,0,0,1-4.539-3.533L112.535,42.781a3.779,3.779,0,0,1,3.043-4.384,2.941,2.941,0,0,1,.67-.052H120.3a1.8,1.8,0,0,1,1.728,1.315h0a1.549,1.549,0,0,0,1.521,1.16h19.237a2.68,2.68,0,0,0,2.682-2.5Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38859",
    "data-name": "Path 38859",
    d: "M164.392,64.39a1.656,1.656,0,0,1,.335.258l12.4-3.172.851-2.991,4.667.7-.98,5.441a2.025,2.025,0,0,1-1.805,1.676L165.4,67.82a2.711,2.711,0,1,1-1.289-3.61,1.065,1.065,0,0,0,.284.181Z",
    fill: "#ffb6b6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 7.994,
    cy: 7.994,
    r: 7.994,
    transform: "translate(147.553 59.62)",
    fill: "#4b4495"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38860",
    "data-name": "Path 38860",
    d: "M160.55,52.27H150.545l-6.034-29.552a11.107,11.107,0,0,1,22.1-2.243,10.624,10.624,0,0,1,0,2.218Z",
    fill: "#4b4495"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38861",
    "data-name": "Path 38861",
    d: "M183.475,61.915l-3.2,2.733-4.461,3.868-1.96-10.109-.206-1.031-.181-.851,4.539-7.865,3.765.206.258.026v.052l.077.516.774,6.963V56.6Z",
    fill: "#48d1cc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38862",
    "data-name": "Path 38862",
    d: "M162.613,130.921h-3.172l-1.5-12.2h4.667Z",
    fill: "#ffb6b6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38863",
    "data-name": "Path 38863",
    d: "M163.412,133.989H153.227v-.129a3.973,3.973,0,0,1,3.971-3.971h6.215Z",
    fill: "#2a2a2a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38864",
    "data-name": "Path 38864",
    d: "M195.62,131.179h-3.172l-1.5-12.2h4.667Z",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38865",
    "data-name": "Path 38865",
    d: "M196.42,134.247H186.234v-.129a3.973,3.973,0,0,1,3.971-3.971h6.215Z",
    fill: "#2a2a2a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38866",
    "data-name": "Path 38866",
    d: "M198.148,125.815l-8.51,1.289L177.26,85.2l-13.151,42.162-9.541-1.289,12.378-49V73.209l1.676-5.8-.181-1.573-1.212-10.985-.516-4.771-.026-.309a1.05,1.05,0,0,1,.825-1.135h0l3.971-.825h6.5l3.842,1.057.258.077.129.026-.052.49-.9,7.53-.052.413-.877,7.246-.181,1.6c7.478,5.415,7.736,10.831,7.736,10.831Z",
    fill: "#2a2a2a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 6.344,
    cy: 6.344,
    r: 6.344,
    transform: "translate(167.564 31.873)",
    fill: "#ffb6b6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22516",
    "data-name": "Rectangle 22516",
    width: 12.636,
    height: 1.805,
    transform: "matrix(0.992, -0.13, 0.13, 0.992, 168.051, 66.427)",
    fill: "#48d1cc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38867",
    "data-name": "Path 38867",
    d: "M151.241,66.969a1.655,1.655,0,0,1,.335.258l12.4-3.172.851-2.991,4.667.7-.98,5.441a2.025,2.025,0,0,1-1.805,1.676L152.247,70.4a2.711,2.711,0,1,1-1.289-3.61,1.065,1.065,0,0,0,.284.181Z",
    fill: "#ffb6b6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38868",
    "data-name": "Path 38868",
    d: "M170.3,50.259l-2.192-1.676c-.593-.232-1.393.413-1.547,1.031L163.464,62.25l6.447,4.642.9-1.418Z",
    fill: "#48d1cc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22354",
    "data-name": "Group 22354",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38869",
    "data-name": "Path 38869",
    d: "M182.882,56.422c-.542.206-1.109.413-1.676.567l-.542.155a16.417,16.417,0,0,1-3.688.593,11.4,11.4,0,0,1-1.625-.052,9.928,9.928,0,0,1-1.7-.335c-.026,0-.052,0-.052-.026a7.555,7.555,0,0,1-3.094-1.754,3.111,3.111,0,0,1-.542-.619,5.507,5.507,0,0,1-1.186-4.255c.026-.129.052-.284.077-.413a7.386,7.386,0,0,1,.387-1.057l.232-.464,2.914-.98h5.544l3.842,1.057.258.026v.052l.129.026-.052.49Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38870",
    "data-name": "Path 38870",
    d: "M169.06,32.982a4.377,4.377,0,0,0-3.4.722,2.189,2.189,0,0,0-.335,3.146c.774.722,1.986.542,3.017.748a4.129,4.129,0,0,1,3.2,3.92c-.026,2.63-2.527,4.616-2.991,7.195a5.648,5.648,0,0,0,1.728,4.874,7.973,7.973,0,0,0,4.848,2.089,15.359,15.359,0,0,0,5.312-.542,14.68,14.68,0,0,0,4.9-2.166,8.007,8.007,0,0,0,3.12-4.281,5.47,5.47,0,0,0-1.083-5.054c-1.393-1.521-3.688-2.063-4.874-3.739-1.341-1.882-.851-4.564-1.934-6.6A6.127,6.127,0,0,0,177,30.506a16,16,0,0,0-4.564-.645,6.251,6.251,0,0,0-2.4.258A2.142,2.142,0,0,0,168.6,31.9,1.172,1.172,0,0,0,169.06,32.982Z",
    fill: "#2a2a2a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertEmptyScreen);
export default __webpack_public_path__ + "static/media/alert_empty_screen.1d2d9d1bba70e341cd070f750955b3d4.svg";
export { ForwardRef as ReactComponent };